import {apiClient} from "../../providers/apiClient";
import Utilities from "../../utils/Utilities";

const mergeComplaints = (parentId, complaints) => {
    const childrenIds = complaints.filter((complain) => complain.id !== parentId)
        .map((complain) => complain.id);

    return apiClient.post(`/api/Report/mergeComplaints`, {parentId, childrenIds});
}

const resendComplaintsToCompany = (complaints) => {
    const ids = complaints.map(item => item.id);
    return apiClient.put(`/api/Report/sendBulkToCompany`, ids);
}

const downloadCsvReport = async (filters) => {
    try {
        const response = await apiClient.get('/api/Report/csv', {
            params: filters,
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        
        const fileName = `complaints-report_${Utilities.formatDateForFilename()}.csv`;

        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Błąd przy pobieraniu pliku CSV:', error);
    }
}


const addAdminComment = (id, comment) => {
    return apiClient.put(`/api/Report/${id}/admin/comment`, {message: comment});
}

const getComplaintById = () => {
    
}

export default {
    mergeComplaints,
    resendComplaintsToCompany,
    downloadCsvReport,
    addAdminComment
}